<template>
  <div>
    <classroom-attachment-create :color="color"/>
    <vx-card v-if="!enablePost" @click="enablePost = true" class="cursor-pointer">
      <div class="flex items-center">
        <vs-avatar class="mr-4" size="50px" :src="userData.profile_picture" v-if="userData && userData.profile_picture"/>
        <h5 class="font-light">Announce something to your class</h5>
      </div>
    </vx-card>
    <vx-card v-if="enablePost">
      <div class="flex items-center mb-3">
        <vs-avatar class="mr-4" size="50px" :src="userData.profile_picture" v-if="userData && userData.profile_picture"/>
        <div>
          <h2 class="font-bold">Create New Post</h2>
          <p class="font-light">Post To Stream</p>
        </div>
      </div>
      <quill-editor class="mb-3" style="min-height: 175px" v-model="postData" :options="editorOption"/>
      <!--- <classroom-attachment-card :color="color" class="mb-5"/> --->
      <div class="flex justify-end">
        <vs-button color="danger" class="mr-2 font-bold" @click="resetPost">Cancel</vs-button>
        <vs-button :color="`#${color}`" class="font-bold" @click="createPost">Create Post</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'
import ClassroomAttachmentCard from '../attachment/ClassroomAttachmentCard'
import ClassroomAttachmentCreate from '../attachment/ClassroomAttachmentCreate'

export default {
  name: 'ClassroomStreamAnnounce',
  data () {
    return {
      enablePost: false,

      postData: null,
      userData: null,

      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'align': []}],
            [{'color': []}, {'background': []}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      }
    }
  },
  components: {
    quillEditor,
    ClassroomAttachmentCard,
    ClassroomAttachmentCreate
  },
  methods: {
    createPost () {
      if (!this.classroomId) return
      const pl = {classroom_id: this.classroomId, post: this.postData}
      this.$http.post('classrooms/posts/create', pl)
        .then(response => {
          if (response.status === 200) {
            this.$vs.notify({
              title: 'Post Created Successfully',
              text: 'Post has been created.',
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
            this.resetPost()
          }
        })
        .catch(exception => {
          this.resetPost()
          let error = 'An unknown error occurred while creating this post'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Create Post',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    },
    fetchUserDetails () {
      this.$http.get('users/@me')
        .then(response => {
          if (response.status === 200) {
            this.userData = response.data.data
          }
        }).catch(() => {})
    },
    resetPost () {
      this.postData = null
      this.enablePost = false
      this.$emit('refresh')
    }
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    color: {
      type: String
    }
  },
  mounted () {
    this.fetchUserDetails()
  }
}
</script>

<style scoped>

</style>
